import { ArrowRight } from 'lucide-react';

export interface ChangeRow {
  label: string;
  /** '—' when there was no value */
  before: string;
  /** '—' when the value is removed */
  after: string;
}

/** Each change as `before → after`, or only the new value where there was none */
export const ChangeRows = ({ rows }: { rows: ChangeRow[] }) => (
  <dl className="divide-y divide-border">
    {rows.map((row) => (
      <div className="grid grid-cols-1 gap-x-3 gap-y-0.5 px-3 py-1.5 sm:grid-cols-[minmax(0,2fr)_minmax(0,3fr)]" key={row.label}>
        <dt className="text-muted-foreground">{row.label}</dt>
        <dd className="flex min-w-0 flex-wrap items-center gap-x-2 tabular-nums">
          {row.before === '—' ? null : (
            <>
              <del className="break-all text-muted-foreground decoration-red-500/70">{row.before}</del>
              <ArrowRight aria-hidden className="size-3.5 shrink-0 text-muted-foreground" />
            </>
          )}
          {row.after === '—' ? <span className="text-muted-foreground">removed</span> : <ins className="break-all font-medium text-foreground no-underline">{row.after}</ins>}
        </dd>
      </div>
    ))}
  </dl>
);
ChangeRows.displayName = 'ChangeRows';
